import React from 'react';
import styled from 'styled-components';

import { primaryColor } from '~theme';

const TagSelection = ({ options, onChange, value }) => {
  const handleClick = filter => {
    if (value.includes(filter)) {
      onChange(value.filter(value => value !== filter));
    } else {
      onChange([...value, filter]);
    }
  };

  return (
    <Container>
      {options.map(option => (
        <Tag
          key={option.key || option.value}
          onClick={() => handleClick(option.value)}
          active={value.includes(option.value)}
        >
          {option.label}
        </Tag>
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > :not(:last-child) {
    margin-right: 7px;
  }

  & > * {
    margin-bottom: 7px;
  }
`;

const Tag = styled.div`
  color: ${props => (props.active ? '#fff' : primaryColor)};
  background-color: ${props => (props.active ? primaryColor : '#fff')};

  padding: 7px 13px;
  border: 1px solid ${primaryColor};
  cursor: pointer;
`;

export default TagSelection;
